import React, { useEffect, useState, useContext, useMemo } from 'react';
import MyInput from '@pagescommon/Inputs/MyInput';
import MyPassword from '@pagescommon/Inputs/MyPassword';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { RestContext } from '@pages/test-development/script/scripts/webservice/restapi/restapi';
import { WEBSERVICE } from '@pages/test-development/script/scripts/webservice/restapi/constants/constants';
import '@pages/test-development/script/scripts/webservice/restapi/css/common_Webservice.scss';
import useSyncContextValues from '@src/hooks/useSyncContextValues';

export default function Digest_auth(props) {
  const context = useContext(RestContext);
  const formik = useFormik({
    initialValues: {
      userName: '',
      password: '',
      ...(context?.values?.digestAuthData || {}),
    },
    validationSchema: Yup.object({
      userName: Yup.string().required(WEBSERVICE.BASIC_USER_NAME),
      password: Yup.string().required(WEBSERVICE.BASIC_PASSWORD),
    }),
  });

  useSyncContextValues(formik, context, 'digestAuthData');
  const [userName, setUserName] = useState('');
  const handleChange = (e) => {
    context.setFieldValue('authType', 'Digest');
    const values = { ...(context?.values?.digestAuthData || {}), [e.target.name]: e.target.value };
    context.setFieldValue('digestAuthData', values);
    formik.handleChange(e);
    formik.validateForm(values).then((errors) => context.setFieldValue('errors', errors));
    props.handleSaveAsSteps(false);
  };

  useEffect(() => {
    formik.validateForm().then((errors) => context.setFieldValue('errors', errors));
  }, []);

  const [authPassword, setAuthPassword] = useState();

  const isEditable = useMemo(() => window.permission?.isEditAccess('testDevelopment'), []);

  useEffect(() => {
    context.setFieldValue('authType', 'Digest');
    return () => context.setFieldValue('currentDigestAuthName', {});
  }, []);
  const nameOnChange = (e) => {
    const { value, data, action, name } = e.target || 'unknown';
    const values = {
      ...(context?.values?.digestAuthData || {}),
      [name]: props?.getUserInputValue(value, false, data, action),
    };
    context.setFieldValue('digestAuthData', values);
    const values2 = { ...(context?.values?.digestData || {}), [name]: value };
    context.setFieldValue('digestData', values2);
    setUserName(value);
    const currentDigestAuthName = { ...(context.values.currentDigestAuthName || {}), [name]: e };
    context.setFieldValue('currentDigestAuthName', currentDigestAuthName);
  };
  const authPwOnChange = (e) => {
    setAuthPassword(e.target.value);
  };
  return (
    <div className="mt-4" style={{ width: '300px' }}>
      <form onSubmit={formik.handleSubmit} className=" basic-auth-form-style" noValidate>
        <div>
          <div className="input-filed-label fontPoppinsMediumSm text-left" onDragStart={props.handleDragStart}>
            {' '}
            <span className="common-auth-star-symbol">*</span> Username
          </div>
          <MyInput
            canCreateVariable={isEditable}
            type="text"
            placeholder="Enter username"
            variableInput={true}
            error={formik.errors.userName && formik.touched.userName}
            value={userName ? userName : props?.getUserInputValue(formik.values.userName, true)}
            onMouseDown={formik.handleBlur}
            onChange={(e) => {
              handleChange(e);
              nameOnChange(e);
            }}
            autoComplete={WEBSERVICE.PREVENT_BROWSER_USERNAME_AUTOFILL}
            name="userName"
            helperText={formik.touched.userName && formik.errors.userName}
            currentValue={context.values.currentDigestAuthName?.userName}
            className="my-input-style-for-authorization"
            inputValue={'input'}
            {...props}
          />
        </div>
        <div className="basic-auth-error-input-alignment">
          <div className="input-filed-label fontPoppinsMediumSm text-left" onDragStart={props.handleDragStart}>
            {' '}
            <span className="common-auth-star-symbol">*</span> Password
          </div>
          <MyPassword
            placeholder="Enter password"
            error={formik.errors.password && formik.touched.password}
            value={authPassword ? authPassword : formik.values.password}
            onBlur={formik.handleBlur}
            autoComplete={WEBSERVICE.PREVENT_BROWSER_PASSWORD_AUTOFILL}
            className="placeholderpass my-password-style-for-authorization"
            onChange={(e) => {
              handleChange(e);
              authPwOnChange(e);
            }}
            name="password"
            helperText={formik.touched.password && formik.errors.password}
            inputValue={'input'}
          />
        </div>
      </form>
    </div>
  );
}
